import { IApplicationContext } from '@helpers/types';
import React from 'react';
import useApplicationContextProvider from './use-application-context-provider';

export const ApplicationContext = React.createContext<IApplicationContext>({});

const ApplicationContextProvider = (props: any) => {
  const defaultContext = useApplicationContextProvider();
  return (
    <ApplicationContext.Provider value={defaultContext}>
      {props.children}
    </ApplicationContext.Provider>
  );
};

export default ApplicationContextProvider;
